export default "/images/de.png?73ebfd813316f7e6d15ac632fc742665";